'use strict';

module.exports = {
    openSearchbar: function () {
        $('body').on('click', '.js-open-search-bar', function (e) {
            e.preventDefault();
            $('.search-suggestions-bar').addClass('d-lg-block');
            $('.js-search-bar-wrapper').addClass('show');
            $('.js-search-bar-wrapper input.search-field').focus();
        });
    },

    closeSearchBar: function () {
        // Close button handler
        $('body').on('click', '.js-close-search-bar', function (e) {
            e.preventDefault();
            var $form = $(this).closest('form');
            $form.trigger('reset');
            $('.search-suggestions-bar').removeClass('d-lg-block');
            $('.js-search-bar-wrapper').removeClass('show');
        });

        // Close on outside click
        $(document).on('click', function (e) {
            const $target = $(e.target);
            if (
                $('.js-search-bar-wrapper').hasClass('show') &&
				!$target.closest('.js-search-bar-wrapper').length &&
				!$target.closest('.js-open-search-bar').length
            ) {
                $('.js-search-bar-wrapper').removeClass('show');
                $('.search-suggestions-bar').removeClass('d-lg-block');
                $('.js-search-bar-wrapper form').trigger('reset');
            }
        });
    },

    viewAllSearch: function () {
        $('body').on('click', '.js-submit-search', function (e) {
            e.preventDefault();
            var $form = $(this).closest('form');
            $form.submit();
        });
    },
};
